<template>
  <div class="product__list__item-row" @click.prevent="openProduct">
    <div
      class="col-12 d-flex align-items-start full-width"
      :class="
        extraPadding
          ? 'product_item__result__link__extra-padding'
          : 'product_item__result__link'
      "
    >
      <font-awesome-icon
        :icon="['fal', 'barcode-scan']"
        class="mr-2 product-icon"
      />
      <div class="min-width-0 overflow">
        <div class="product-label-span">{{ product.reference }}</div>
        <ProductParameters
          class="mt-1"
          v-if="product.denormalizedParameters"
          :parameters="product.denormalizedParameters"
          :breadcrumb="product.breadcrumb"
        />
      </div>
    </div>
  </div>
</template>

<script>
import ProductParameters from '@/components/SuperSearch/ProductParameters';

export default {
  name: 'product-list-item',
  components: {
    ProductParameters,
  },
  props: {
    product: Object,
    extraPadding: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    openProduct() {
      this.$emit('open-product', this.product);
    },
  },
};
</script>

<style lang="scss" scoped>
.product__list__item-row {
  padding: 4px 0px;
  display: flex;
  align-items: center;
  &:hover {
    background-color: $grey-1-mayday;
    cursor: pointer;
    & .product-icon {
      color: $blue-mayday;
    }
  }
  .product-icon {
    height: 16px;
    width: 16px;
  }
}

.product-label-span {
  line-height: 16px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.min-width-0 {
  min-width: 0;
}

.overflow {
  overflow: hidden;
  white-space: nowrap;
}

.product_item__result__link {
  padding: 0px 12px 0px 8px;

  &__extra-padding {
    padding: 0px 24px 0px 30px;
  }
}
</style>
